/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'create': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M79.582 52.547v20.371c0 10.57-8.598 19.168-19.168 19.168H27.082c-10.57 0-19.168-8.598-19.168-19.168V39.586c0-10.57 8.598-19.168 19.168-19.168h20.371a2.5 2.5 0 110 5H27.082c-7.813 0-14.168 6.355-14.168 14.168v33.332c0 7.812 6.355 14.168 14.168 14.168h33.332c7.812 0 14.168-6.356 14.168-14.168V52.547a2.5 2.5 0 115 0zm10-32.129h-10v-10a2.5 2.5 0 10-5 0v10h-10a2.5 2.5 0 100 5h10v10a2.5 2.5 0 105 0v-10h10a2.5 2.5 0 100-5z"/>'
  }
})
